import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/nav-selector';

export const SeasonNavItem = ( {
    updateNavSelection,
    seasons,
} ) => {
    const nav = useSelector( statsLeadersNavSelector );
    
    return (
        <Select
            items={ seasons }
            itemToString={ season => season.name }
            initialSelectedItem={ seasons.length && nav.season.id ? seasons.find( s => s.id === nav.season.id ) : '' }
            isReadyToRender={ () => seasons.length && nav.season.id }
            label={ getTranslation( 'label.statsLeaders.nav.season' ) }
            onSelectedItemChange={ ( { selectedItem: season } ) => {
                updateNavSelection( 'season', { id: season.id } );
            } }
        />
    );
};

SeasonNavItem.propTypes = {
    updateNavSelection: PropTypes.func.isRequired,
    seasons: PropTypes.array.isRequired
};